/**
 * Validates and normalizes currency code.
 * Returns a valid currency code or a default fallback.
 *
 * @param currency - The currency code to validate
 * @param fallback - The fallback currency code (defaults to 'USD')
 * @returns A valid currency code
 */
export const getValidateCurrencyCode = (
  currency: string | undefined,
  fallback = 'USD'
): string => {
  // Check if currency is undefined, null, empty string, or only whitespace
  if (!currency || currency.trim() === '') {
    return fallback
  }

  // Validate that currency code is at least 3 characters (ISO 4217 standard)
  if (currency.length < 3) {
    return fallback
  }

  return currency.trim().toUpperCase()
}
